/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const Vue = require('vue');
const VueRouter = require('vue-router');
const nameSpace = require('src/common/utils/nameSpace')

Vue.use(VueRouter)

nameSpace ('AB', "router")
nameSpace ('COMMON', "router")

const router = window.AB.router = window.COMMON.router = new VueRouter();

module.exports = router;




// WEBPACK FOOTER //
// ./src/appBackend/router.js